// extracted by mini-css-extract-plugin
export default {"heading":"w2O9rarzBldsZOLOOPvg","reviewButton":"LY9La3Iz49iLhUYIFJOK"};